<!--  -->
<template>
  <div class="add_box">
    <div class="serach_box">
      <div class="search_box">
        <el-input v-model="objr.func_config_id" style="width:200px;" placeholder="请输入功能id" />
        <el-button type="primary" icon="el-icon-search" style="margin:0" @click="sraw">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" style="margin:0" @click="reast">重置</el-button>
        <el-button type="success" icon="el-icon-plus" style="margin:0" @click="addset">ota功能配置添加</el-button>
        <el-button type="success" icon="el-icon-plus" style="margin:0" @click="addbit">ota升级创建</el-button>
      </div>
    </div>

    <!-- <el-button type="primary" @click="awered">重置</el-button> -->
    <el-table
      :data="tableData"
      border
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        prop="func_desc"
        align="center"
        label="功能名称"
        width="180"
      />
      <el-table-column
        prop="file_url"
        align="center"
        label="文件名称"
        width="180"
      />
      <el-table-column
        prop="created_at"
        align="center"
        label="创建时间"
        width="180"
      >
        <template scope="scope">
          {{ timestampToTime(scope.row.created_at) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="admin_name"
        align="center"
        label="创建人"
        width="180"
      />

      <el-table-column
        align="center"
        prop="work_status"
        label="操作"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <!-- <el-button type="warning" size="mini" @click="edit(scope.row)">编辑</el-button> -->
          <el-button type="warning" size="mini" @click="issued(scope.row)">下发</el-button>
          <!-- <el-button type="danger" size="mini" @click="deleter(scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      ref="paginationbox"
      :total="newtotalr"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />
    <el-dialog
      title="ota升级创建/编辑"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
    >
      <otadialog ref="choosecontentimgview" @updata="updata" />
    </el-dialog>
    <el-dialog
      title="ota功能配置添加"
      :visible.sync="dialogVisibletot"
      :destroy-on-close="true"
    >
      <otaconfigure ref="otaconfigureview" @updatatot="updatatot" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import otadialog from './components/otadialog.vue'
import otaconfigure from './components/otaconfigure.vue'
import { otalist, issuedota } from '@/api/sourceMaterial.js'
export default {
  name: 'Ota',
  components: {
    PaginationRight,
    otadialog,
    otaconfigure
  },
  data() {
    return {
      dialogVisible: false,
      dialogVisibletot: false,
      newtotalr: null,
      adtype: null,
      objr: {
        page: 1,
        page_size: 10,
        func_config_id: null
      },
      tableData: []
    }
  },
  created() {
    this.menuList()
  },
  mounted() {

  },
  methods: {
    async menuList() {
      // 获取列表
      const data = await otalist(this.objr)
      console.log('data', data)
      this.tableData = data.data.list
      this.newtotalr = data.data.total
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.pageSize = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },
    edit(item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.choosecontentimgview.send(item, 2)
      })
    },
    addbit() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.choosecontentimgview.send({}, 1)
      })
    },
    sraw() {
      this.objr.page = 1
      this.menuList()
    },
    reast() {
      this.objr.page = 1
      this.objr.func_config_id = null
      this.menuList()
    },
    addset() {
      this.dialogVisibletot = true
    },
    updata() {
      this.dialogVisible = false
      this.menuList()
    },
    updatatot() {
      this.dialogVisibletot = false
    },
    issued(item) {
      console.log('item', item)
      this.$confirm('确定下发吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        issuedota({
          id: item.id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '下发成功!'
          })
          this.menuList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消下发'
        })
      })
    },
    deleter(item) {
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        issuedota({
          id: item.id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.menuList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp * 1000)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
      var h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':'
      var m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':'
      var s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds())
      return Y + M + D + h + m + s
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box{
  padding: 20px;
}
.serach_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
